import { Injectable } from "@angular/core";
import moment from "moment";

@Injectable({
  providedIn: "root",
})
export class thEnConverterService {
  constructor() {}

  convertThaiEpochToEnglishEpoch(thaiEpoch: number): number {
    const thaiDate = new Date(thaiEpoch * 1000);
    const gregorianYear = thaiDate.getFullYear() - 543;
    const gregorianDate = new Date(
      gregorianYear,
      thaiDate.getMonth(),
      thaiDate.getDate(),
      thaiDate.getHours(),
      thaiDate.getMinutes(),
      thaiDate.getSeconds()
    );
    return Math.floor(gregorianDate.getTime() / 1000);
  }

  convertToThaiDate(unixTimestamp: number): string { 
    try {
      // If it's a 13-digit timestamp, take the first 10 digits
      const timestamp = unixTimestamp.toString().length === 13 
        ? Math.floor(unixTimestamp / 1000) 
        : unixTimestamp;
  
      const date = new Date(timestamp * 1000);  // Convert to milliseconds
      const thaiYear = date.getFullYear() + 543;
      const thaiMonth = String(date.getMonth() + 1).padStart(2, "0");
      const thaiDay = String(date.getDate()).padStart(2, "0");
  
      const thaiTime = date.toLocaleTimeString("th-TH", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
  
      return `${thaiDay}/${thaiMonth}/${thaiYear} ${thaiTime}`;
    } catch (error) {
      return '';
    }
  }
  convertThaiDateString(birthDate: string): string {
    // return moment(birthDate, "D MMMM YYYY", "th")
    //   .add(543, "years")
    //   .format("YYYY-MM-DD");
    const date = new Date(birthDate);

    // Convert to Thai Buddhist year (B.E. = A.D. + 543)
    const thaiYear = date.getFullYear() + 543;
    const thaiMonth = (date.getMonth() + 1).toString().padStart(2, '0');
    const thaiDay = date.getDate().toString().padStart(2, '0');

    return `${thaiYear}-${thaiMonth}-${thaiDay}`;
  }

  // convert 08/04/2025 format to 08/04/2568 format
  convertThaiDate(birthDate: string): string {
    return moment(birthDate, "DD/MM/YYYY", "th") // Corrected input format
      .add(543, "years") // Add 543 years for the Thai Buddhist calendar
      .format("DD/MM/YYYY"); // Output in the desired format
  }

  convertThaiDateFormat(birthDate: string): string {
    return moment(birthDate, "D MMMM YYYY", "th")
      .add(543, "years")
      .format("DD-MM-YYYY hh:mm A"); 
  }

  convertToThaiFullDate(isoDate: string, value?): string {
    if(!isoDate){
      return "";
    }
    const date = new Date(isoDate);

    // Convert to Thai Buddhist year (B.E. = A.D. + 543)
    const thaiYear = date.getFullYear() + 543;
    const thaiMonth = (date.getMonth() + 1).toString().padStart(2, '0');
    const thaiDay = date.getDate().toString().padStart(2, '0');

    // Convert to 12-hour format with AM/PM
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const period = hours >= 12 ? 'หลังเที่ยง' : 'ก่อนเที่ยง';

    // Convert 24-hour format to 12-hour format
    if (hours > 12) {
      hours -= 12;
    } else if (hours === 0) {
      hours = 12;
    }

    const formattedTime = `${hours}:${minutes} ${period}`;
    return value == 'ref' ? `${thaiDay}/${thaiMonth}/${thaiYear}` : `${thaiDay}/${thaiMonth}/${thaiYear} ${formattedTime}`;
  }
  convertToThaiFullDateWithOutTime(isoDate: string): string {
    const date = new Date(isoDate);

    // Convert to Thai Buddhist year (B.E. = A.D. + 543)
    const thaiYear = date.getFullYear() + 543;
    const thaiMonth = (date.getMonth() + 1).toString().padStart(2, '0');
    const thaiDay = date.getDate().toString().padStart(2, '0');

   
    return `${thaiDay}/${thaiMonth}/${thaiYear}`;
  }
  convertToThaiFullDateWithTime(isoDate: string): string {
  const date = new Date(isoDate);

  // Convert to Thai Buddhist year
  const thaiYear = date.getFullYear() + 543;

  // Use Intl.DateTimeFormat for Thai localization
  const formatter = new Intl.DateTimeFormat('th-TH', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });

  // Format date in Thai
  let formatted = formatter.format(date);

  // Adjust output to match your "at" format
  // Replace locale words to Thai natural phrasing
  // Example: "วันอังคารที่ 25 กันยายน 2568 02:21:04 หลังเที่ยง"
  formatted = formatted
    .replace(/(\d{4})/, `พ.ศ. $1`) // Insert พ.ศ. before the year
    .replace('หลังเที่ยง', 'น.')  // PM → น.
    .replace('ก่อนเที่ยง', 'น.'); // AM → น.

  // Add Thai-style "เวลา" (means "at time")
  formatted = formatted.replace(/(\d{4})/, `$1 เวลา`);

  return formatted;
}
  convertTo12HourFormat(time24: string): string {
    const [hours, minutes] = time24.split(':').map(Number);
    const period = hours >= 12 ? 'หลังเที่ยง' : 'ก่อนเที่ยง';
    const hours12 = hours % 12 || 12;
    return `${this.padZero(hours12)}:${this.padZero(minutes)} ${period}`;
  }
  
  padZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }
convertThaiDateToEnglishDateString(thaiDate: string): string {
    const [thaiYear, month, day] = thaiDate.split('-').map(Number);
    const today = new Date();
    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth() + 1;  
    const todayDay = today.getDate();
  
    if (
      thaiYear === todayYear  && 
      month === todayMonth &&
      day === todayDay
    ) {
      return thaiDate; 
    }
  
    const gregorianYear = thaiYear - 543;
    const gregorianDate = new Date(gregorianYear, month - 1, day);
    const year = gregorianDate.getFullYear();
    const formattedMonth = (gregorianDate.getMonth() + 1).toString().padStart(2, '0');
    const formattedDay = gregorianDate.getDate().toString().padStart(2, '0');
  
    return `${year}-${formattedMonth}-${formattedDay}`;
  }
  convertThaiDateInFormat(indentDate: string): string {
    if(!indentDate) {
      return "";
    }
    let parts = indentDate.split(" ")[0].split("/");
    let day = +parts[0];
    let month = +parts[1] - 1;
    let year = +parts[2] ; 
  
    return `${year}-${month}-${day}`;
  }
  conertdateInFormat(dateStr: string): string {
  
    const date = new Date(dateStr); 
  
    if (isNaN(date.getTime())) {
      return '';
    }
  
    const thaiYear = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${thaiYear}-${month}-${day}`;
  }
  convertNewEpochThaiToEnglish(thaiDateStr: string): number {
    if(!thaiDateStr) {
      return null;
    }
    const thaiDate = new Date(thaiDateStr);
    const thaiYear = thaiDate.getFullYear();
  
    const gregorianYear = thaiYear > 2500 ? thaiYear - 543 : thaiYear;
    const correctedDate = new Date(
      gregorianYear,
      thaiDate.getMonth(),
      thaiDate.getDate(),
      thaiDate.getHours(),
      thaiDate.getMinutes(),
      thaiDate.getSeconds()
    );
  
    return Math.floor(correctedDate.getTime() / 1000);
  }
  
  convertEpochThaiToEnglish( thaiEpoch): number| string | null {
    if (thaiEpoch === "") {
      return "";
    }
    if (thaiEpoch === 0) {
      return 0;
    }
    if (thaiEpoch === null || thaiEpoch === undefined || isNaN(thaiEpoch)) {
      return null;
    }
    const thaiDate = new Date(thaiEpoch * 1000);
    const today = new Date();
    
    // Check if the passed epoch is today's date
    if (
      thaiDate.getFullYear() === today.getFullYear() &&
      thaiDate.getMonth() === today.getMonth() &&
      thaiDate.getDate() === today.getDate()
    ) {
      return thaiEpoch;
    }
    
    const gregorianYear = thaiDate.getFullYear() - 543;
    const gregorianDate = new Date(
      gregorianYear,
      thaiDate.getMonth(),
      thaiDate.getDate(),
      thaiDate.getHours(),
      thaiDate.getMinutes(),
      thaiDate.getSeconds()
    );
    return Math.floor(gregorianDate.getTime() / 1000);
  }
  convertToThaiTime(isoDate: string): string {
    const date = new Date(isoDate);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const period = hours >= 12 ? 'หลังเที่ยง' : 'ก่อนเที่ยง';
  
    if (hours > 12) {
      hours -= 12;
    } else if (hours === 0) {
      hours = 12;
    }
  
    return `${hours}:${minutes} ${period}`;
  }

  convertToThaiFullDateWithOutTimeddmmyy(isoDate: string): string {
    const date = new Date(isoDate);

    // Convert to Thai Buddhist year (B.E. = A.D. + 543)
    const thaiYear = date.getFullYear() + 543;
    const thaiMonth = (date.getMonth() + 1).toString().padStart(2, '0');
    const thaiDay = date.getDate().toString().padStart(2, '0');

   
    return `${thaiDay}-${thaiMonth}-${thaiYear}`;
  }

  convertToThaiFullDateWithDayTime(isoDate: string): string {
    const date = new Date(isoDate);
  
    // Convert to Thai Buddhist year (B.E. = A.D. + 543)
    const thaiYear = date.getFullYear() + 543;
  
    // Get full month name in Thai
    const thaiMonths = [
      'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
      'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
    ];
    const thaiMonth = thaiMonths[date.getMonth()];
  
    // Get full day name in Thai
    const thaiDays = [
      'อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'
    ];
    const thaiDayName = thaiDays[date.getDay()];
  
    const thaiDay = date.getDate();
  
    // Convert to 12-hour format with AM/PM
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const period = hours >= 12 ? 'หลังเที่ยง' : 'ก่อนเที่ยง';
  
    // Convert 24-hour format to 12-hour format
    if (hours > 12) {
      hours -= 12;
    } else if (hours === 0) {
      hours = 12;
    }
  
    const formattedTime = `${hours}.${minutes} ${period}`;
  
    return `${thaiDayName}, ${thaiMonth} ${thaiDay}, ${thaiYear}, ${formattedTime}`;
  }
  //Date come from backend like "09/04/2025 02:44 PM"
  convertToThaiFullDatefromFormattedDate(dateString: string): string {
    const parts = dateString.split(/[\s:]+/);
    const [datePart, hourStr, minuteStr, , period] = parts;
    const [day, month, year] = datePart.split('/').map(Number);
    let hours = parseInt(hourStr, 10);
    const minutes = parseInt(minuteStr, 10);
  
    if (period.toUpperCase() === 'PM' && hours < 12) {
      hours += 12;
    } else if (period.toUpperCase() === 'AM' && hours === 12) {
      hours = 0;
    }
  
    const date = new Date(year, month - 1, day, hours, minutes);
    const thaiYear = date.getFullYear() + 543;
    const thaiMonth = (date.getMonth() + 1).toString().padStart(2, '0');
    const thaiDay = date.getDate().toString().padStart(2, '0');
  
    let displayHours = date.getHours();
    const displayMinutes = date.getMinutes().toString().padStart(2, '0');
    const thaiPeriod = displayHours >= 12 ? 'หลังเที่ยง' : 'ก่อนเที่ยง';
  
    if (displayHours > 12) {
      displayHours -= 12;
    } else if (displayHours === 0) {
      displayHours = 12;
    }
  
    const formattedTime = `${displayHours}:${displayMinutes} ${thaiPeriod}`;
    return `${thaiDay}/${thaiMonth}/${thaiYear} ${formattedTime}`;
  }
  convertToThaiTimeString(timeString: string): string {
    // Expects input like "10:59 AM"
    const [time, period] = timeString.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
  
    const thaiPeriod = period === 'AM' ? 'ก่อนเที่ยง' : 'หลังเที่ยง';
  
    if (period === 'PM' && hours < 12) {
      hours += 12;
    } else if (period === 'AM' && hours === 12) {
      hours = 0;
    }
  
    if (hours > 12) hours -= 12;
    if (hours === 0) hours = 12;
  
    return `${hours}:${minutes.toString().padStart(2, '0')} ${thaiPeriod}`;
  }
  
}
